export enum TipoSLA {
  ANTIGO = 1,
  COM_ORIGEM,
  SEM_ORIGEM,
}
